import script from "./elmentItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./elmentItem.vue?vue&type=script&lang=ts&setup=true"

import "./elmentItem.vue?vue&type=style&index=0&id=1817c936&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1817c936"]])

export default __exports__